import { t } from '../i18n';
import logoDark from '@/images/logo.png';
import slideOneImage1 from '@/images/slider/slider-1.jpg';
import slideOneImage2 from '@/images/slider/slider-2.jpg';
import funfactShape from '@/images/shape/about-shape.png';

import comment1 from '@/images/comment-1.jpg';
import comment2 from '@/images/comment-2.jpg';

export const Logo = {
  dark: logoDark,
};

export const NavLinksData = [
  {
    name: 'home',
    url: '/',
  },
  {
    name: 'about',
    url: '/about',
  },
  {
    name: 'services',
    url: '/service',
  },
];

export const TopbarInfos = [
  {
    icon: 'icon-placeholder',
    tagLine: 'topbar.address',
    text: 'topbar.addressText',
    url: '#',
  },
  // {
  //   icon: "icon-phone-call",
  //   tagLine: "Call Now",
  //   text: "666 888 000",
  //   url: "tel:666-888-000",
  // },
  {
    icon: 'icon-clock',
    tagLine: 'topbar.openhours',
    text: 'topbar.openhoursText',
    url: '#',
  },
];

export const SlideOneData = [
  {
    backgroundImage: slideOneImage1,
    title: t('slider.slide1.title'),
    text: t('slider.slide1.text'),
    button: t('slider.slide1.button'),
    url: '/contact',
  },
  {
    backgroundImage: slideOneImage2,
    title: t('slider.slide2.title'),
    text: t('slider.slide2.text'),
    button: t('slider.slide2.button'),
    url: '/services',
  },
];

export const FeatureOneData = [
  {
    icon: 'icon-wallet',
    title: 'features.feature1',
  },
  {
    icon: 'icon-diploma',
    title: 'features.feature2',
  },
  {
    icon: 'icon-big_clock',
    title: 'features.feature3',
  },
  {
    icon: 'icon-handshake',
    title: 'features.feature4',
  },
  {
    icon: 'icon-building',
    title: 'features.feature5',
  },
];

export const AboutOneData = {
  title: t('about.title'),
  tagLine: t('about.tagLine'),
  content: t('about.content'),
  button: {
    url: '/about',
    label: t('about.button'),
  },
};

export const ServiceOneData = {
  title: 'services.title',
  posts: [
    {
      image: slideOneImage1,
      icon: 'icon-truck',
      title: 'services.service1.title',
      text: 'services.service1.text',
      button: {
        label: 'services.service1.button',
        url: '/service',
      },
    },
    {
      image: slideOneImage2,
      icon: 'icon-plane',
      title: 'services.service2.title',
      text: 'services.service2.text',
      button: {
        label: 'services.service2.button',
        url: '/service',
      },
    },
  ],
};

export const CallToActionOneData = {
  title: 'callToAction.title',
  button: {
    url: '/contact',
    label: 'callToAction.button',
  },
};

export const CallToActionTwoData = {
  left: {
    text: 'Air Conditioning Services',
    title: 'Cool it down',
  },
  right: {
    text: 'Heating Services',
    title: 'Heat it up',
  },
};

export const FunfactOneData = {
  shapeImage: funfactShape,
  title: t('funfact.title'),
  posts: [
    {
      count: 5000,
      text: t('funfact.fact1'),
    },
    {
      count: 8200,
      text: t('funfact.fact2'),
    },
    {
      count: 2500,
      text: t('funfact.fact3'),
    },
  ],
};

export const FooterBottomData = {
  social: [
    {
      icon: 'fa fa-twitter',
      url: 'http://x.com/',
    },
    {
      icon: 'fa fa-facebook-f',
      url: 'https://facebook.com',
    },
    {
      icon: 'fa fa-linkedin',
      url: 'https://linkedin.com',
    },
  ],
};

export const FooterInfo = [
  {
    icon: 'icon-placeholder',
    tagLine: 'footer.address',
    text: 'topbar.addressText',
    url: '#',
  },
  {
    icon: 'icon-placeholder',
    tagLine: 'footer.tradingAddress',
    text: 'footer.tradingAddressText',
    url: '#',
  },
  {
    icon: 'icon-contact',
    tagLine: 'footer.email',
    text: 'info@shamy.eu',
    url: 'mailto:info@shamy.eu',
  },
  {
    icon: 'icon-clock',
    tagLine: 'footer.openHours',
    text: 'topbar.openhoursText',
    url: '#',
  },
];

export const FooterWidgets = {
  about: {
    title: 'footer.about.title',
    text: 'footer.about.text',
    phone: '+32478074368',
  },
  linkOne: {
    title: 'footer.quickLinks',
    menu: [
      {
        lable: 'footer.links.services',
        url: '/services',
      },
      {
        lable: 'footer.links.aboutUs',
        url: '/about',
      },
    ],
  },
  linkTwo: {
    menu: [],
  },
};

export const VideoOneData = {
  title: 'Watch how we work',
  id: '8DP4NgupAhI',
};

export const AboutTwoData = {
  caption: '4 + <span>years of expertise</span>',
  blockTitle: {
    title: 'aboutPage.trustTitle',
    tagline: 'aboutPage.whyChooseUs',
  },
  lists: [
    {
      text: 'aboutPage.benefits.benefit1',
    },
    {
      text: 'aboutPage.benefits.benefit2',
    },
    {
      text: 'aboutPage.benefits.benefit3',
    },
    {
      text: 'aboutPage.benefits.benefit4',
    },
    {
      text: 'aboutPage.benefits.benefit5',
    },
    {
      text: 'aboutPage.benefits.benefit6',
    },
  ],
};

export const AboutThreeData = {
  blockTitle: {
    tagline: 'Our success story',
    title: 'Experience quality air conditioning service in broklyn new york',
  },
  summery:
    "There are many variations of passages of lorem ipsum available, but the majorify have suffered alteration in some form by injected humour, or randmised words which don't look even slightly believable.",
  button: {
    lable: 'LEARN MORE',
    url: '/about',
  },
  box: [
    {
      icon: 'icon-maintenance',
      title: 'We make as cool again',
    },
    {
      icon: 'icon-big-ac',
      title: 'Keep your business cool',
    },
  ],
};

export const AboutFourData = {
  blockTitle: {
    title: 'aboutPage.aboutSection.title',
    text1: 'aboutPage.aboutSection.text1',
    text2: 'aboutPage.aboutSection.text2',
  },
};

export const BenefitOneData = {
  title: 'benefitSection.title',
  posts: [
    {
      icon: 'icon-globe',
      title: 'benefitSection.benefit1.title',
      text: 'benefitSection.benefit1.text',
    },
    {
      icon: 'icon-truck',
      title: 'benefitSection.benefit2.title',
      text: 'benefitSection.benefit2.text',
    },
    {
      icon: 'icon-shield',
      title: 'benefitSection.benefit3.title',
      text: 'benefitSection.benefit3.text',
    },
    {
      icon: 'icon-briefcase',
      title: 'benefitSection.benefit4.title',
      text: 'benefitSection.benefit4.text',
    },
  ],
};

export const ServiceSidebarListData = [
  {
    icon: 'icon-snow',
    title: 'Cooling Services',
    list: [
      {
        label: 'Air Conditioner Maintenance',
        url: '#',
      },
      {
        label: 'Air Conditioner Repair',
        url: '#',
      },
      {
        label: 'Air Conditioner Replacement',
        url: '#',
      },
      {
        label: 'Ductless Split AC Systems',
        url: '#',
      },
      {
        label: 'Duct Cleaning & Installation',
        url: '#',
      },
    ],
  },
  {
    icon: 'icon-fire',
    title: 'Heating Services',
    list: [
      {
        label: 'Air Conditioner Maintenance',
        url: '#',
      },
      {
        label: 'Air Conditioner Repair',
        url: '#',
      },
      {
        label: 'Air Conditioner Replacement',
        url: '#',
      },
      {
        label: 'Ductless Split AC Systems',
        url: '#',
      },
      {
        label: 'Duct Cleaning & Installation',
        url: '#',
      },
    ],
  },
];

export const ServicesPage = {
  title: 'services.pageTitle',
};

export const ServiceSidebarOtherData = [
  {
    icon: 'icon-ac',
    title: 'Other Services',
    content: {
      icon: 'icon-support',
      title: '<span>Contact with us </span>666 888 000',
    },
  },
  {
    icon: 'icon-building',
    title: 'Commercial Services',
    content: {
      icon: 'icon-building',
      title: '<span>Contact with us </span>666 888 000',
    },
  },
];

export const CommentPostData = [
  {
    name: 'David Martin',
    image: comment1,
    time: '10 Nov, 2018 - 4:00 pm',
    text: 'Lorem Ipsum is simply dummy text of the rinting and typesetting been the industry standard dummy text ever sincer condimentum purus. In non ex at ligula fringilla lobortis et aliquet.',
  },
  {
    name: 'Jessica Brown',
    image: comment2,
    time: '10 Nov, 2018 - 4:00 pm',
    text: 'Lorem Ipsum is simply dummy text of the rinting and typesetting been the industry standard dummy text ever sincer condimentum purus. In non ex at ligula fringilla lobortis et aliquet.',
  },
];

export const ContactPage = {
  title: 'contactScreen.title',
  subtitle: 'contactScreen.subtitle',
  form: {
    name: 'contactScreen.form.name',
    email: 'contactScreen.form.email',
    phone: 'contactScreen.form.phone',
    message: 'contactScreen.form.message',
    submitBtn: 'contactScreen.form.submitBtn',
  },
  heading: 'contactScreen.heading',
  title1: 'contactScreen.title1',
  subtitle1: 'contactScreen.subtitle1',
};
